import { render, staticRenderFns } from "./partnerDeposit.vue?vue&type=template&id=c6d51882&"
import script from "./partnerDeposit.vue?vue&type=script&lang=js&"
export * from "./partnerDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports